import React from 'react';
import styles from './Quiz.module.css';
import { Link, withRouter } from 'react-router-dom';
import * as utils from '../../utils/utils';
import EmailAuth from '../../components/EmailAuth/EmailAuth';
import { FiArrowLeftCircle } from 'react-icons/fi';
import Header from '../../components/Header/Header';
import Ad from '../../components/Ad/Ad';

export default class Quiz extends React.Component {

    constructor(props) {
        super(props);

        const isDev = (process.env.NODE_ENV === 'development');

        if ( isDev ) {
            this.scheme = 'vibegame-app-dev';
        }
        else {
            this.scheme = 'vibegame-app';
        }

        this.categoryWeekID = +this.props.match.params.categoryWeekID || 1;
        this.quizNum = +this.props.match.params.quizNum || 0;
        this.title = this.props.match.params.title || '';

        this.state = {
            isLoading: true,

            quizID: null,
            questions: null,
            isShowingAnswers: false,

            showEmailAuth: false,
        };
    };

    componentDidMount() {
        if (
            !(
                this.categoryWeekID === 1 &&
                this.quizNum === 0
            ) &&
            !utils.isLoggedIn()
        ) {
            this.setState({
                showEmailAuth: true,
            });

            return;
        }

        utils.sendRequest('/web/quiz/getQuiz',{
            categoryWeekID: this.categoryWeekID,
            quizNum: this.quizNum,
        })
        .then(responseData => {
            const {
                quizID,
                questions,
            } = responseData;

            // randomize questions and options orders.
            this.shuffleArray(questions);

            const options = ['a', 'b', 'c', 'd'];
            questions.forEach((questionItem, questionIndex) => {

                const optionsOrder = [...options];
                this.shuffleArray(optionsOrder);
                
                questionItem.optionsOrder = optionsOrder;

                questionItem.isOptionsAChosen = false;
                questionItem.isOptionsBChosen = false;
                questionItem.isOptionsCChosen = false;
                questionItem.isOptionsDChosen = false;
            })

            this.setState({
                quizID,
                questions,
                isLoading: false,
            });
        })
        .catch(error => {
            console.log('error', error);
        });
    };

    checkAnswers = () => {
        utils.sendRequest('/web/quiz/getQuizAnswers',{
            quizID: this.state.quizID,
        })
        .then(responseData => {
            const {
                questions,
            }= this.state;

            responseData.answers.forEach(answerItem => {
                const questionID = answerItem.question_id;

                questions.forEach(questionItem => {
                    if ( questionItem.question_id === questionID ) {
                        questionItem.answers = [];
                        questionItem.answerExplanation = answerItem.answer_explanation;

                        if ( answerItem.answers.includes('A') ) {
                            questionItem.answers.push(questionItem.option_a);
                        }
                        if ( answerItem.answers.includes('B') ) {
                            questionItem.answers.push(questionItem.option_b);
                        }
                        if ( answerItem.answers.includes('C') ) {
                            questionItem.answers.push(questionItem.option_c);
                        }
                        if ( answerItem.answers.includes('D') ) {
                            questionItem.answers.push(questionItem.option_d);
                        }
                    }
                });
            });

            this.setState({
                questions,
                isShowingAnswers: true,
            }, () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        })
        .catch(error => {
            console.log('error', error);
        });
    };

    chooseAnswer = (questionIndex, option) => {
        const {
            questions
        } = this.state;

        if ( option === 'a' ) {
            questions[questionIndex].isOptionsAChosen = !questions[questionIndex].isOptionsAChosen;
        }
        else if ( option === 'b' ) {
            questions[questionIndex].isOptionsBChosen = !questions[questionIndex].isOptionsBChosen;
        }
        else if ( option === 'c' ) {
            questions[questionIndex].isOptionsCChosen = !questions[questionIndex].isOptionsCChosen;
        }
        else if ( option === 'd' ) {
            questions[questionIndex].isOptionsDChosen = !questions[questionIndex].isOptionsDChosen;
        }

        this.setState({
            questions,
        });
    };

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            let temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    };

    render() {
        const {
            isLoading,
            questions,
            isShowingAnswers,
            showEmailAuth,
        } = this.state;

        return (
            <div className={styles.rootView}>
                {/* <img src={require('../../assets/animation.gif')} className={styles.background} /> */}
                <div className={styles.background} />

                <Header />

                <div className={styles.content}>

                    <div className={styles.verticalGap} />

                    <div
                        className={styles.backButtonView}
                        onClick={() => window.history.back()}
                    >
                        <FiArrowLeftCircle color='#032d7388' />
                        <div>Back</div>
                    </div>

                    <div className={styles.title}>
                        "{this.title}" Quiz
                    </div>

                    <div className={styles.quizListView}>
                        <div className={styles.quizListRowView}>
                            <a href={`/categoryWeek/${this.categoryWeekID}/0/${this.title}`}>
                                <div className={this.quizNum === 0 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 1</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/1/${this.title}`}>
                                <div className={this.quizNum === 1 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 2</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/2/${this.title}`}>
                                <div className={this.quizNum === 2 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 3</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/3/${this.title}`}>
                                <div className={this.quizNum === 3 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 4</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/4/${this.title}`}>
                                <div className={this.quizNum === 4 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 5</div>
                            </a>
                        </div>
                        <div className={styles.quizListRowView}>
                            <a href={`/categoryWeek/${this.categoryWeekID}/5/${this.title}`}>
                                <div className={this.quizNum === 5 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 6</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/6/${this.title}`}>
                                <div className={this.quizNum === 6 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 7</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/7/${this.title}`}>
                                <div className={this.quizNum === 7 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 8</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/8/${this.title}`}>
                                <div className={this.quizNum === 8 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 9</div>
                            </a>
                            <a href={`/categoryWeek/${this.categoryWeekID}/9/${this.title}`}>
                                <div className={this.quizNum === 9 ? styles.quizListItemSelected : styles.quizListItem}>Quiz 10</div>
                            </a>
                        </div>
                    </div>

                    <Ad />

                    {
                        isLoading ?
                        <div>Loading questions...</div> :
                        <>

                            {
                                questions.map((questionItem, questionIndex) => {
                                    return (
                                        <div key={questionItem.question_id} className={styles.questionItem}>
                                            <div className={styles.questionView}>
                                                <div className={styles.questionText}>{questionItem.question}</div>
                                            </div>
                                            <div className={styles.optionsView}>
                                                {
                                                    questionItem.optionsOrder.map(option => {
                                                        if ( option === 'a' ) {
                                                            return (
                                                                <div
                                                                    key={`${questionItem.question_id}_option_a`}
                                                                    onClick={() => this.chooseAnswer(questionIndex, 'a')}
                                                                    className={questionItem.isOptionsAChosen ? styles.optionItemSelectedView : styles.optionItemView}
                                                                >{questionItem.option_a}</div>
                                                            );
                                                        }
                                                        if ( option === 'b' ) {
                                                            return (
                                                                <div
                                                                    key={`${questionItem.question_id}_option_b`}
                                                                    onClick={() => this.chooseAnswer(questionIndex, 'b')}
                                                                    className={questionItem.isOptionsBChosen ? styles.optionItemSelectedView : styles.optionItemView}
                                                                >{questionItem.option_b}</div>
                                                            );
                                                        }
                                                        if ( option === 'c' ) {
                                                            return (
                                                                <div
                                                                    key={`${questionItem.question_id}_option_c`}
                                                                    onClick={() => this.chooseAnswer(questionIndex, 'c')}
                                                                    className={questionItem.isOptionsCChosen ? styles.optionItemSelectedView : styles.optionItemView}
                                                                >{questionItem.option_c}</div>
                                                            );
                                                        }
                                                        if ( option === 'd' ) {
                                                            return (
                                                                <div
                                                                    key={`${questionItem.question_id}_option_d`}
                                                                    onClick={() => this.chooseAnswer(questionIndex, 'd')}
                                                                    className={questionItem.isOptionsDChosen ? styles.optionItemSelectedView : styles.optionItemView}
                                                                >{questionItem.option_d}</div>
                                                            );
                                                        }
                                                    })
                                                }
                                                {/* <div className={styles.answerItemView}>{question.option_a}</div>
                                                <div className={styles.answerItemView}>{question.option_b}</div>

                                                <div className={styles.answerItemView}>{question.option_c}</div>
                                                <div className={styles.answerItemView}>{question.option_d}</div> */}
                                            </div>
                                            {
                                                isShowingAnswers &&
                                                <div className={styles.answersView}>
                                                    <div>Correct Answer(s):</div>
                                                    <ul>
                                                        {questionItem.answers.map(answer => {
                                                            return (
                                                                <li>{answer}</li>
                                                            )
                                                        })}
                                                    </ul>
                                                    <div>Explanation:</div>
                                                    <ul>
                                                        <li>{questionItem.answerExplanation}</li>
                                                    </ul>
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </>
                    }

                    <Ad />

                    <div
                        className={styles.button}
                        onClick={this.checkAnswers}
                    >
                        <div>Check Answers</div>
                    </div>

                    <div className={styles.footer}>
                        {/* <a href='mailto:vibegameapp@gmail.com' className={styles.link}>Help</a> */}
                        <Link to="/terms" className={styles.link}>Terms</Link>
                        <Link to="/privacy" className={styles.link}>Privacy</Link>
                    </div>
                    <div className={styles.copyright}>© KVK LLC. 2025</div>
                </div>

                {
                    showEmailAuth &&
                    <EmailAuth />
                }
            </div>
        );
    };
};